import { qnTexts } from '../themes/_palette';

export const MuiList = {
    styleOverrides: {
        root: {
            padding: 8,
            color: qnTexts.darkGreyMediumEmphasis
        }
    }
}
